import React from 'react';
import { useTranslation } from 'react-i18next';

import { MailTemplateToHtml } from '../../functions';

import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';

type TypeEIValue = {
  key: string;
  value: string;
};

type Props = {
  template: string;
  ei_values: TypeEIValue[];
  toggleModal: () => void;
  isOpen: boolean;
  translate?: (key: string, defaultValue: string) => string;
};

export const PreviewModal = ({
  template,
  ei_values,
  toggleModal,
  isOpen,
  translate,
}: Props): JSX.Element => {
  const preview = MailTemplateToHtml(template, ei_values);
  const { t } = useTranslation();

  const trans = translate || t;
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{t('lbl.preview', 'Preview')}</ModalHeader>
      <ModalBody>
        <div
          style={{
            border: '2px solid black',
            backgroundColor: 'white',
            color: 'black',
            zoom: '60%',
          }}
          dangerouslySetInnerHTML={{ __html: preview }}
        ></div>
      </ModalBody>
      <ModalFooter>
        <button
          className={'em-cancel-button'}
          onClick={toggleModal}
          data-testid="cancel"
        >
          {trans('fn.cancel', 'Cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};
